import React, { Component } from 'react';
import { DetailsFooter, FooterBtns, FooterBtn } from './CapaLlegendaFooterElements';
import { TaulaFilter } from '../CapaLlegendaFooter/Components/Taula/TaulaFilter';
import { getTranslatedKey } from '../../../Utils/TranslateUtils';
import { displayComponents } from '../../../Utils/VisorsUtils';
import StatsSelector from '../CapaLlegendaFooter/Components/Estadisticas/StatsSelector';
import { zoomMapToBBOX } from '../../../Utils/MapUtils';
import LayerStyles from './Components/Styles/LayerStyles';
import Transparency from './Components/Transparency/Transparency';
import ExportLayer from './Components/Export/ExportLayer';
import {
  getTransparencyIcon,
  getInfoIcon,
  getInfoDisabledIcon,
  getMetadataIcon,
  getStylesIcon,
  getAddElementIcon,
  getFilterIcon,
  getTableIcon,
  getStatsIcon,
  getExportIcon,
  getCloseIcon,
  getZoomIcon
} from './CapaLlegendaFooterIcons/CapaLlegendaFooterIcons';
import { config } from '../../../../config/Config';
import { getLayerBboxWFS } from '../../../Utils/LayerUtils';
export class CapaLlegendaFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStylesPopUp: false, //booleano para mostrar el div de cambiar estilos
      showExportPopUp: false, //booleano para mostrar el div de exportar la capa
      showSearchPopUp: false, //booleano para mostrar el div de busqueda
      isInformationShow: true, //booleano de si esta activa la informacion de la capa
      isCloseHovered: false,
      isStylesHovered: false,
      isTransparencyHovered: false,
      isExportHovered: false,
      isInformationHovered: false,
      openFilters: false,
      popUpOpen: false,
      downloading: false
    };
  }
  selectField = (field) => {
    this.setState({ statsField: field });
  };
  /**
   *
   * @desc Función para quitar una capa de la leyenda
   */
  onCloseBtnClick = () => {
    let index = this.props.arrayLayers.findIndex((l) => l.getName() === this.props.layer.getName());
    if (index !== undefined) {
      this.props.layer.setExpanded(false);
      this.props.layer.setTransPopUpOpen(false);
      this.props.layer.setVisible(true);
      this.props.layer.setExportOpen(false);
      this.props.layer.setStylesOpen(false);
      this.props.layer.setStatsOpen(false);

      if (this.props.layer.getOLLayer() !== undefined) {
        this.props.map.removeLayer(this.props.layer.getOLLayer());
        this.props.layer.getOLLayer().setOpacity(100 / 100);
        this.props.layer.setStyleSelected(0);
        this.props.layer.setOLLayer(undefined);
      }
      this.props.layer.setChecked(false);
      this.props.arrayLayers.splice(index, 1);
      if (this.props.layer.isExternal()) {
        let extLayer = this.props.arrayExternalLayers.findIndex((l) => l.getTitle() === this.props.layer.getTitle());
        this.props.arrayExternalLayers.splice(extLayer, 1);
      }
      this.props.handleDeleteLayer(this.props.layer);
      this.props.deleteTaula(this.props.layer);
      this.forceUpdate();
    }
  };

  /**
   *
   * @desc Función para cambiar el estado del boton de transparencia de la capa (mostrar o no slider)
   */
  onTransparencyBtnClick = () => {
    if (!this.props.layer.isTransPopUpOpen()) {
      //si hay algun otro popup mostrado se quita
      this.setState({ showSearchPopUp: false });
      this.props.layer.setExportOpen(false);
      this.props.layer.setFiltresOpen(false);
      this.props.layer.setStatsOpen(false);
      this.props.layer.setStylesOpen(false);
    }
    this.props.layer.setTransPopUpOpen(!this.props.layer.transPopUpOpen);
    this.forceUpdate();
  };

  /**
   *
   * @desc Función para cambiar el estado del boton de exportación de la capa
   */
  onExportBtnClick = () => {
    if (!this.props.layer.isExternal()) {
      if (!this.props.layer.isExportOpen()) {
        //si hay algun otro popup mostrado se quita
        this.setState({ showSearchPopUp: false });
        this.props.layer.setStylesOpen(false);
        this.props.layer.setTransPopUpOpen(false);
        this.props.layer.setFiltresOpen(false);
        this.props.layer.setStatsOpen(false);
      }
      this.props.layer.setExportOpen(!this.props.layer.isExportOpen());
    }
    this.forceUpdate();
  };

  /**
   *
   * @desc Función para mostrar una nueva ventana con los metadatos de la capa
   */
  onMetadataBtnClick = () => {
    if (this.props.layer.getIndexUUID() !== undefined) {
      let url = config.url_metadata + this.props.layer.getIndexUUID();
      let popup = window.open(url, 'Metadades', 'width=800,height=600,scrollbars=yes');
      this.setState({ popUpOpen: true });
      const checkPopupClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopupClosed);
          this.handlePopupClosed();
        }
      }, 200);
    } else if (this.props.layer.getIndexURL() !== undefined) {
      let popup = window.open(this.props.layer.getIndexURL(), 'Metadades', 'width=800,height=600,scrollbars=yes');
      this.setState({ popUpOpen: true });
      const checkPopupClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopupClosed);
          this.handlePopupClosed();
        }
      }, 200);
    }
  };

  handlePopupClosed = () => {
    this.setState({ popUpOpen: false });
  };
  /**
   *
   * @desc Función para abrir el popup de cambiar los estilos seleccionados de una capa
   */
  onEstilsBtnClick = () => {
    if (this.props.layer.getNumStyles() > 1 || this.props.layer.isTemporal()) {
      //miramos si tiene estilos para mostrar
      if (!this.props.layer.isStylesOpen()) {
        //si hay algun otro popup mostrado se quita
        this.props.layer.setExportOpen(false);
        this.props.layer.setTransPopUpOpen(false);
        this.props.layer.setFiltresOpen(false);
        this.props.layer.setStatsOpen(false);

        this.setState({ showSearchPopUp: false });
      }
      this.props.layer.setStylesOpen(!this.props.layer.isStylesOpen());
      this.forceUpdate();
    }
  };

  handleClosePopUp = () => {
    this.props.layer.setTransPopUpOpen(false);
    this.forceUpdate();
  };

  handleCloseStyles = () => {
    this.props.layer.setStylesOpen(false);
    this.forceUpdate();
  };

  handleExportClose = () => {
    this.props.layer.setExportOpen(false);
    this.forceUpdate();
  };

  useForceUpdate = () => {
    this.forceUpdate();
  };

  addFeature = () => {
    if (this.props.layer.getExtension()?.Editable === 'true') {
      this.props.setEditing('draw', this.props.layer, 'create');
    }
  };

  openTableFilters = () => {
    if (!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()) {
      this.props.layer.setFiltresOpen(!this.props.layer.isFiltresOpen());
      this.props.layer.setStylesOpen(false);
      this.props.layer.setTransPopUpOpen(false);
      this.props.layer.setStatsOpen(false);
      this.props.layer.setExportOpen(false);
      this.setState({});
    }
  };
  openStatistic = () => {
    if (!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()) {
      this.props.layer.setStatsOpen(!this.props.layer.isStatsOpen());
      this.props.layer.setStylesOpen(false);
      this.props.layer.setFiltresOpen(false);
      this.props.layer.setTransPopUpOpen(false);
      this.props.layer.setExportOpen(false);
      this.setState({});
    }
  };

  handleTableCreate = (e) => {
    if (!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()) {
      //Si no hay tabla creada
      if (this.props.taulaArray[this.props.layer.getTitle()] === undefined) {
        this.props.getTaulaArray(this.props.layer, 0, {});
      } else {
        //Si se hace click en el icono teniendo la tabla seleccionada
        if (this.props.taulaLayer === this.props.layer && this.props.taulaOpen) {
          this.props.closeTable(this.props.layer.getTitle(), e);
        } else {
          this.props.setTaulaLayer(this.props.layer);
        }
      }
    } else if (this.props.layer.isTemporal()) {
      if (this.props.taulaArray[this.props.layer.getTitle()] === undefined) {
        this.props.getExternTable(this.props.layer);
      } else {
        //Si se hace click en el icono teniendo la tabla seleccionada
        if (this.props.taulaLayer === this.props.layer && this.props.taulaOpen) {
          this.props.closeTable(this.props.layer.getTitle(), e);
        } else {
          this.props.setTaulaLayer(this.props.layer);
        }
      }
    }
  };

  handleZoomToLayer = async () => {
    this.setState({ movilZoomHover: true });
    setTimeout(() => {
      this.setState({ movilZoomHover: false });
    }, 1000);

    let bbox = this.props.layer.getBbox();

    if (this.props.layer.isTemporal()) {
      zoomMapToBBOX(this.props.map, bbox, 0, true);
      return;
    }

    if (this.props.layer.isExternal() === false) {
      if (this.props.taulaFullFilter[this.props.layer.getTitle()] !== undefined || !bbox) {
        bbox = await getLayerBboxWFS(this.props.taulaFullFilter[this.props.layer.getTitle()], this.props.layer);
      } else if (!bbox) {
        bbox = await getLayerBboxWFS(undefined, this.props.layer);
      }
      zoomMapToBBOX(this.props.map, bbox, 0, true);
    }
  };

  render() {
    return (
      <>
        <DetailsFooter>
          <FooterBtns>
            {displayComponents.transCapa && (
              <FooterBtn
                id="transparenciaBtn"
                title={getTranslatedKey('transparency')}
                onClick={() => this.onTransparencyBtnClick()}
                isShow={this.props.layer.isTransPopUpOpen() || this.props.layer.getOLLayer()?.getOpacity() !== 1}
                isHover={this.state.isTransparencyHovered}
                isEnabled={true}
                onMouseEnter={() => this.setState({ isTransparencyHovered: true })}
                onMouseLeave={() => this.setState({ isTransparencyHovered: false })}>
                {getTransparencyIcon(this.props.fontSizeEnabled, this.props.layer)}
              </FooterBtn>
            )}
            {displayComponents.infoCapa && (
              <FooterBtn
                id="infoBtn"
                title={getTranslatedKey('showInfo')}
                isEnabled={true}
                display={this.props.layer.isTemporal()}
                isShow={!this.props.layer.hasInfoEnabled()}
                isHover={this.state.isInformationHovered}
                onClick={() => {
                  this.setState({
                    isInformationShow: !this.props.layer.hasInfoEnabled()
                  });
                  this.props.layer.setInfoEnabled(!this.props.layer.hasInfoEnabled());
                  this.props.handleEraseInfoCard(this.props.layer);
                }}
                className={`${this.props.layer.hasInfoEnabled() ? 'info-btn' : ''}`}
                onMouseEnter={() => this.setState({ isInformationHovered: true })}
                onMouseLeave={() => this.setState({ isInformationHovered: false })}>
                {this.props.layer.hasInfoEnabled() ? getInfoIcon(this.props.fontSizeEnabled) : getInfoDisabledIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.metadadesCapa && (
              <FooterBtn
                id="metadataBtn"
                title={getTranslatedKey('metadata')}
                display={this.props.layer.isTemporal()}
                isInformationShow={this.props.isInformationShow}
                isShow={this.state.popUpOpen}
                isHover={this.state.isMetadataHovered}
                isEnabled={this.props.layer.hasMetadata()}
                onClick={() => this.onMetadataBtnClick()}
                className={`${this.props.layer.hasMetadata() && !this.props.layer.isTemporal() ? 'metadata-btn' : ''}`}
                onMouseEnter={() => this.setState({ isMetadataHovered: true })}
                onMouseLeave={() => this.setState({ isMetadataHovered: false })}>
                {getMetadataIcon(this.props.fontSizeEnabled, this.props.layer)}
              </FooterBtn>
            )}
            {displayComponents.styleCapa && (
              <FooterBtn
                id="stylesBtn"
                title={getTranslatedKey('stylesSelect')}
                onClick={() => this.onEstilsBtnClick()}
                isShow={this.props.layer.isStylesOpen() || this.props.layer.getStyleSelected() !== 0}
                isHover={this.state.isStylesHovered}
                className={`${this.props.layer.getNumStyles() > 1 && !this.props.layer.isStylesOpen() ? 'estils-btn' : ''}`}
                isEnabled={this.props.layer.getNumStyles() > 1 || this.props.layer.isTemporal()}
                onMouseEnter={() => this.setState({ isStylesHovered: true })}
                onMouseLeave={() => this.setState({ isStylesHovered: false })}>
                {getStylesIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.edicio && (
              <FooterBtn
                id="addBtn"
                title={getTranslatedKey('addElement')}
                isShow={this.props.layer.isEditOpen()}
                isHover={this.state.isEditHovered}
                isEnabled={this.props.layer.getExtension()?.Editable === 'true'}
                onClick={() => this.addFeature()}
                className="edit-btn"
                onMouseEnter={() => this.setState({ isEditHovered: true })}
                onMouseLeave={() => this.setState({ isEditHovered: false })}>
                {getAddElementIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.llegendaFiltre && (
              <FooterBtn
                onMouseEnter={() => this.setState({ isFilterHovered: true })}
                onMouseLeave={() => this.setState({ isFilterHovered: false })}
                isHover={this.state.isFilterHovered}
                id="filterBtn"
                title={getTranslatedKey('layerFilter')}
                hasFilters={
                  this.props.taulaFullFilter[this.props.layer.getTitle()] !== undefined &&
                  this.props.taulaFullFilter[this.props.layer.getTitle()] !== ''
                }
                isShow={this.props.layer.isFiltresOpen()}
                isEnabled={!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()}
                onClick={() => {
                  this.openTableFilters();
                }}>
                {getFilterIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.taulaDadesCapa && (
              <FooterBtn
                onMouseEnter={() => this.setState({ isTableHover: true })}
                onMouseLeave={() => this.setState({ isTableHover: false })}
                isHover={this.state.isTableHover}
                id="tableBtn"
                title={getTranslatedKey('taulaCapa')}
                className={`${
                  !this.props.layer.isExternal() &&
                  (this.props.taulaArray[this.props.layer.getTitle()] === undefined || this.props.taulaArray[this.props.layer.getTitle()] === '')
                    ? 'table-btn'
                    : ''
                }`}
                isShow={this.props.taulaArray[this.props.layer.getTitle()] !== undefined}
                isEnabled={(!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()) || this.props.layer.isTemporal()}
                onClick={(e) => {
                  this.handleTableCreate(e);
                }}>
                {getTableIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.statsCapa && (
              <FooterBtn
                onMouseEnter={() => this.setState({ isStatsHover: true })}
                onMouseLeave={() => this.setState({ isStatsHover: false })}
                isHover={this.state.isStatsHover}
                id="StatsBtn"
                title={getTranslatedKey('layerStats')}
                className={'stats-button'}
                isShow={this.props.statsLayer?.getName() === this.props.layer.getName() || this.props.layer.isStatsOpen()}
                isEnabled={!this.props.layer.isExternal() && !this.props.layer.isRasterLayer()}
                onClick={() => {
                  this.openStatistic();
                }}>
                {getStatsIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
            {displayComponents.exportarCapa && (
              <FooterBtn
                id="exportBtn"
                title={getTranslatedKey('export')}
                isShow={this.props.layer.isExportOpen()}
                isHover={this.state.isExportHovered}
                isEnabled={!this.props.layer.isExternal()}
                onClick={() => this.onExportBtnClick()}
                className={`${!this.props.layer.isExternal() && !this.props.layer.isExportOpen() ? 'export-btn' : ''}`}
                onMouseEnter={() => this.setState({ isExportHovered: true })}
                onMouseLeave={() => this.setState({ isExportHovered: false })}>
                {getExportIcon(this.props.fontSizeEnabled, this.props.layer)}
              </FooterBtn>
            )}
            {displayComponents.zoomCapa && (
              <FooterBtn
                id="zoomBtn"
                title={getTranslatedKey('layerZoom')}
                onMouseEnter={() => this.setState({ isZoomToLayerHover: true })}
                onMouseLeave={() => this.setState({ isZoomToLayerHover: false })}
                isEnabled={!this.props.layer.isExternal() || this.props.layer.isTemporal()}
                className={`${!this.props.layer.isExternal() ? 'zoom-btn' : ''}`}
                isHover={this.state.isZoomToLayerHover}
                onClick={() => this.handleZoomToLayer()}>
                {getZoomIcon(this.props.fontSizeEnabled, this.props.layer, this.state.isZoomToLayerHover, this.state.movilZoomHover)}
              </FooterBtn>
            )}
            {displayComponents.eliminarCapa && displayComponents.cataleg && (
              <FooterBtn
                id="closeBtn"
                title={getTranslatedKey('closeLayer')}
                isHover={this.state.isCloseHovered}
                isEnabled={true}
                onClick={() => this.onCloseBtnClick()}
                className="close-btn"
                onMouseEnter={() => this.setState({ isCloseHovered: true })}
                onMouseLeave={() => this.setState({ isCloseHovered: false })}>
                {getCloseIcon(this.props.fontSizeEnabled)}
              </FooterBtn>
            )}
          </FooterBtns>
        </DetailsFooter>
        {/* COMPONENTES */}
        {this.props.layer.isFiltresOpen() && (
          <TaulaFilter
            taulaApiConditions={this.props.taulaApiConditions}
            taulaGeom={this.props.taulaGeom}
            taulaFc={this.props.taulaFc}
            taulaTotal={this.props.taulaTotal}
            taulaPage={this.props.taulaPage}
            setTaulaGeom={this.props.setTaulaGeom}
            user={this.props.user}
            scrollToFiltre={this.props.scrollToFiltre}
            taulaFullFilter={this.props.taulaFullFilter}
            fontSizeEnabled={this.props.fontSizeEnabled}
            setTaulaSpacialBbox={this.props.setTaulaSpacialBbox}
            taulaSpacialBbox={this.props.taulaSpacialBbox}
            setTaulaSpacialFilter={this.props.setTaulaSpacialFilter}
            taulaSpacialFilter={this.props.taulaSpacialFilter}
            deleteTaula={this.props.deleteTaula}
            changeLlegendaOpen={(isOpen) => this.props.changeLlegendaOpen(isOpen)}
            taulaResp={this.props.taulaResp}
            setTaulaResp={this.props.setTaulaResp}
            setTaulaConditions={this.props.setTaulaConditions}
            taulaConditions={this.props.taulaConditions}
            taulaArray={this.props.taulaArray}
            selectVector={this.props.selectVector}
            taulaFilters={this.props.taulaFilters}
            arrayLayers={this.props.arrayLayers}
            isSelecting={this.props.isSelecting}
            resetSelected={this.props.resetSelected}
            selectedArray={this.props.selectedArray}
            selectedFeatures={this.props.selectedFeatures}
            toggleSelecting={this.props.toggleSelecting}
            getTaulaArray={this.props.getTaulaArray}
            setTaulaFilters={this.props.setTaulaFilters}
            openTableFilters={this.openTableFilters}
            filterVector={this.props.filterVector}
            filterSource={this.props.filterSource}
            map={this.props.map}
            layer={this.props.layer}
            toggleDrawing={this.props.toggleDrawing}></TaulaFilter>
        )}
        {this.props.layer.isStatsOpen() && (
          <StatsSelector
            user={this.props.user}
            openStatistic={this.openStatistic}
            selectField={this.selectField}
            statsLayerSelect={this.props.statsLayerSelect}
            layer={this.props.layer}
          />
        )}
        {this.props.layer?.isStylesOpen() && (
          <LayerStyles
            update={this.props.update}
            handleCloseStyles={this.handleCloseStyles}
            taulaFullFilter={this.props.taulaFullFilter}
            handleStyleChanged={this.props.handleStyleChanged}
            map={this.props.map}
            layer={this.props.layer}
            arrayLayers={this.props.arrayLayers}
            onStyleChangeOrder={this.props.onStyleChangeOrder}
            fontSizeEnabled={this.props.fontSizeEnabled}
          />
        )}
        {this.props.layer.isTransPopUpOpen() && (
          <Transparency layer={this.props.layer} fontSizeEnabled={this.props.fontSizeEnabled} handleClosePopUp={this.handleClosePopUp} />
        )}
        {this.props.layer.isExportOpen() && (
          <ExportLayer
            user={this.props.user}
            taulaFullFilter={this.props.taulaFullFilter}
            showAlert={this.props.showAlert}
            toggleAlert={this.props.toggleAlert}
            layer={this.props.layer}
            fontSizeEnabled={this.props.fontSizeEnabled}
            handleExportClose={this.handleExportClose}
          />
        )}
      </>
    );
  }
}
